import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { createAddon, editAddon, showAddon } from '~/config/routes';
import List from './List';
import New from './New';
import Edit from './Edit';
import Show from './Show';
import { AddonProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function Addon() {
  return (
    <AddonProvider>
      <Switch>
        <Route
          exact
          path={createAddon.spec}
          render={(props) => (
            <>
              <Can I="new" a="Addons">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="Addons">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editAddon.spec}
          render={(props) => (
            <>
              <Can I="edit" a="Addons">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="Addons">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showAddon.spec}
          render={(props) => (
            <>
              <Can I="show" a="Addons">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="Addons">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />

        <Route
          render={(props) => (
            <>
              <Can I="list" a="Addons">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="Addons">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </AddonProvider>
  );
}
export default Addon;
